module.exports = __webpack_public_path__ + "static/img/GY.5bfac901.svg";